export const canLoadOrgSettings = (organization?: { hasAccess?: boolean; isOrgOwner?: boolean } | null): boolean =>
    !!(organization?.hasAccess || organization?.isOrgOwner);
